import { Link } from "react-router-dom";
import { MessageCircle, Mail } from "lucide-react";
import { ADDRESSES } from "@/lib/contracts";

const footerLinks = [
  { href: "/", label: "Home" },
  { href: "/how-it-works", label: "How It Works" },
  { href: "/collection", label: "Gallery" },
  { href: "/docs", label: "Docs" },
];

const socialLinks = [
  {
    href: "https://x.com/UKnow_CatStonks",
    icon: () => (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        width="18"
        height="18"
        aria-hidden="true"
      >
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
    label: "X (Twitter)",
  },
  { href: "", icon: MessageCircle, label: "Discord" },
  { href: "", icon: Mail, label: "Email" },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-card/30">
      <div className="container mx-auto px-4 py-12">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <Link to="/" className="inline-block">
              <span className="font-pixel text-sm text-primary">CAT CLAW</span>
            </Link>
            <p className="mt-4 text-sm text-muted-foreground">
              1,024 pixel cats earning you NVDA + SPCX + SPY.
              <br />
              An NFT-Fi experiment on Robinhood Chain.
            </p>
          </div>

          <div>
            <h4 className="font-semibold">Links</h4>
            <ul className="mt-4 space-y-2">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground transition-colors hover:text-primary"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold">Community</h4>
            <div className="mt-4 flex gap-3">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                if (!social.href) {
                  return (
                    <span
                      key={social.label}
                      className="rounded-full border border-border p-2 text-muted-foreground/50"
                      aria-label={`${social.label} (coming soon)`}
                    >
                      <Icon size={18} />
                    </span>
                  );
                }
                return (
                  <Link
                    key={social.label}
                    to={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-full border border-border p-2 text-muted-foreground transition-colors hover:border-primary hover:text-primary"
                    aria-label={social.label}
                  >
                    <Icon size={18} />
                  </Link>
                );
              })}
            </div>
            <p className="mt-4 break-all font-mono text-xs text-muted-foreground">
              CATCLAW: {ADDRESSES.CATCLAW}
            </p>
          </div>
        </div>

        <div className="mt-12 border-t border-border pt-8 text-center text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Cat Claw. All rights reserved.</p>
          <p className="mt-2">
            This website does not constitute investment advice. NFTs and cryptocurrencies carry high risk; please participate carefully.
          </p>
        </div>
      </div>
    </footer>
  );
}
